module.exports = __webpack_public_path__ + "media/asset/images/loginIcon-af0d0750540a578f58cef4bf8e1a78c2.svg";